import React, { useState } from "react";
import "./OrderCard.css";
import { faAngleRight, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
// import OrderTrackModal from '../common_modal/order_track_modal/OrderTrackModal';
import { useNavigate } from "react-router-dom";
import OrderTrackModal from "../../../../../Common_modal/order_track_modal/OrderTrackModal";
import { VerticalLinearStepper } from "../../../../../Common_modal/order_track_modal/order_progress_stepper/OrderProgressStepper";
import { formatCustomDate } from "../../../../../../utils/common";

const OrderCard = ({ type, data, statusText, extraClass, ...props }) => {
  const [showCouponModal, setShowCouponModal] = useState(false);

  const navigate = useNavigate();

  return (
    <section className="OrderCard">
      <div className="card_main_holder">
        <div className="card_holder">
          <div className="right_side_part">
            {props?.orderId ? (
              /* ----------------- ORDER VIEW ----------------- */
              <div className="order_details_div">
                <div
                  className="first_div"
                  onClick={() => {
                    if (props?.navigate) {
                      navigate(props?.navigate);
                    }
                  }}
                >
                  {type && <p className="order_id">Type : {data?.type}</p>}

                  <p className="order_id">Order ID : {props?.orderId}</p>
                  <div className="date_holder">
                    <p>{props?.date}</p>
                  </div>
                </div>

                <div className="order_id_div">
                  <div className="left_detail_holder">
                    <p className="item">{props?.items} Items</p>
                  </div>

                  {props?.showtracking && (
                    <div
                      className="track_order_status"
                      onClick={() => {
                        setShowCouponModal(true);
                      }}
                    >
                      Track Order
                    </div>
                  )}
                </div>

                <div className="footer_text">
                  <div className="delivery_text">
                    <p className="amount_text">Total Amount: ₹ {props?.kwd}</p>
                    <p
                      style={{ color: props?.footer_text_color }}
                      className="status_text"
                    >
                      {props?.footer_text}
                    </p>
                  </div>

                  {statusText && (
                    <div className="status_text_holder">
                      <p className={`Status_text ${extraClass}`}>
                        {statusText}
                      </p>
                    </div>
                  )}

                  {data?.message && (
                    <div className="status_text_holder">
                      <p className={`Status_text ${extraClass}`}>
                        {data?.message}
                      </p>
                    </div>
                  )}

                  {!props?.showViewDetails && (
                    <p
                      className="view_details_text"
                      onClick={() => {
                        navigate(props?.navigate);
                      }}
                    >
                      View Details
                    </p>
                  )}
                </div>
              </div>
            ) : type ? (
              /* ----------------- TYPE VIEW ----------------- */
              <div className="order_details_div">
                <div className="first_div">
                  <p className="order_id">Type : {data?.type}</p>
                  <div className="date_holder">
                    <p>{props?.date}</p>
                  </div>
                </div>

                <div className="footer_text">
                  <div className="delivery_text">
                    <p className="amount_text">Total Amount: ₹ {props?.kwd}</p>
                  </div>
                </div>
              </div>
            ) : (
              /* ----------------- MESSAGE VIEW ----------------- */
              <>
                <div className="date_time_holder">
                  <p>{formatCustomDate(data?.createdAt)}</p>
                </div>
                {data?.message}
              </>
            )}
          </div>
        </div>
      </div>
      {/* 
       <VerticalLinearStepper
        order={props.order}
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
      /> */}

      <OrderTrackModal
        order={props.order}
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
      />
    </section>
  );
};

export default OrderCard;
